<template>
  <div class="home_box">
    <div class="en_box" v-if="$i18n.language == 'en'">
      <img src="../assets/images/官网首页-en.jpg" alt="" />
    </div>
    <div class="home_page" v-else>
      <div class="banner">
        <img src="../assets/images/官网首页_02.jpg" alt="" />
      </div>
      <div class="about_us">
        <div class="image">
          <img src="../assets/images/官网首页_03.jpg" alt="" />
        </div>
      </div>
      <div class="sqyl_box">
        <div class="title">
          <img src="../assets/images/官网首页_04.jpg" alt="" />
        </div>
        <div class="image">
          <img src="../assets/images/官网首页_05.jpg" alt="" />
        </div>
      </div>
      <div class="xsyl_box">
        <div class="title">{{ $t("home.onlineMedical") }}</div>
        <div class="img_list">
          <div class="img">
            <img src="../assets/images/img1.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("home.xjdd") }}</div>
              <div class="tips">
                {{ $t("home.xjdd.desc") }}
              </div>
            </div>
          </div>
          <div class="img">
            <img src="../assets/images/img2.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("home.jhyy") }}</div>
              <div class="tips">
                {{ $t("home.jhyy.desc") }}
              </div>
            </div>
          </div>
          <div class="img">
            <img src="../assets/images/img3.png" alt="" />
            <div class="text_box">
              <div class="title1">{{ $t("home.xsxc") }}</div>
              <div class="tips">
                {{ $t("home.xsxc.desc") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jykj_box">
        <img src="../assets/images/jykj_img.png" alt="" />
      </div>
      <div class="hxjzl_box">
        <div class="title">
          <img src="../assets/images/hxjzl_title.png" alt="" />
        </div>
        <div class="hxjzl_content">
          <img src="../assets/images/官网首页_08.jpg" alt="" />
          <!-- <div class="item_box">
            <div class="img">
              <img src="../assets/images/img4.png" alt="" />
            </div>
            <div class="”tips_box”">
              <div class="”title1”">{{ $t("about.standardization") }}</div>
              <div class="”tips”">
                {{ $t("about.standardization.desc") }}
              </div>
            </div>
          </div>
          <div class="”item_box”">
            <div class="”tips_box”">
              <div class="”title1”">{{ $t("about.tcmFamilyDoctor") }}</div>
              <div class="”tips”">
                {{ $t("about.tcmFamilyDoctor.desc") }}
              </div>
            </div>
            <div class="img">
              <img src="../assets/images/img5.png" alt="" />
            </div>
          </div> -->
        </div>
      </div>
      <div class="szhjs_box">
        <img src="../assets/images/官网首页_09.jpg" alt="" />
      </div>
      <div class="zyxt_box">
        <img src="../assets/images/zyxt_img.png" alt="" />
      </div>
      <div class="news_box">
        <div class="title">{{ $t("home.news") }}</div>
        <div class="new_list" v-if="newsList.length > 0">
          <div class="news" @click="$router.push('/News')">
            <div class="tag">{{ $t("home.tag.hot") }}</div>
            <div class="img">
              <img
                :src="
                  newsList[0].newsPhoto
                    ? newsList[0].newsPhoto
                    : '../assets/images/img4.png'
                "
                alt=""
              />
            </div>
            <div class="tips_box">
              <div class="title2">{{ newsList[0].newsHead }}</div>
              <div class="tips">{{ newsList[0].newsAbstract }}</div>
            </div>
          </div>
          <div class="news" @click="$router.push('/News')">
            <div class="tag">{{ $t("home.tag.hot") }}</div>
            <div class="img">
              <img
                :src="
                  newsList[1].newsPhoto
                    ? newsList[1].newsPhoto
                    : '../assets/images/img4.png'
                "
                alt=""
              />
            </div>
            <div class="tips_box">
              <div class="title2">{{ newsList[1].newsHead }}</div>
              <div class="tips">{{ newsList[1].newsAbstract }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  data() {
    return {
      newsList: [],
      total: 0,
    };
  },
  mounted() {
    this.getNews();
  },
  methods: {
    getNews() {
      let params = {
        pn: 1,
        rows: 10,
      };
      this.$api.getNews(params).then(({ data: { data } }) => {
        this.newsList = data.list;
        this.total = data.total;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.home_box {
  width: 100%;
  height: 100%;
  .en_box {
    width: 100%;
    height: auto;
    margin-top: -110px;
    img {
      width: 100%;
      height: auto;
    }
  }
}
.home_page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;

  .banner {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
      height: auto;
    }
  }

  .about_us {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    background-color: #f8f8f8;

    .image {
      width: 100%;
      height: auto;

      img {
        width: 100%;
      }
    }
  }

  .sqyl_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: auto;

      img {
        width: 100%;
      }
    }

    .image {
      width: 100%;
      height: auto;

      img {
        width: 100%;
      }
    }
  }

  .xsyl_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: 180px;
      font-size: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .img_list {
      width: 100%;
      max-width: 1400px;
      height: auto;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .img {
        width: 30%;
        border-radius: 20px;
        overflow: hidden;
        position: relative;
        cursor: pointer;

        &:hover {
          .text_box {
            top: 0%;
          }
        }

        img {
          width: 100%;
          height: auto;
        }

        .text_box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: -100%;
          transition: all 0.3s;
          padding: 30px;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-direction: column;
          background-color: rgba(0, 0, 0, 0.3);
          color: rgba(255, 255, 255, 1);

          .title1 {
            width: 100%;
            font-size: 40px;
            font-weight: bold;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          .tips {
            width: 100%;
            font-size: 20px;
            font-weight: bold;
            text-align: left;
          }
        }
      }
    }
  }

  .jykj_box {
    width: 100%;
    height: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .hxjzl_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: auto;

      img {
        width: 100%;
      }
    }

    .hxjzl_content {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      background-color: #e8fbff;

      .item_box {
        width: 70%;
        margin: 0 auto;
        margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .img {
          width: 52%;
          height: auto;
          border-radius: 16px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            border-radius: 16px;
          }
        }

        .tips_box {
          width: 48%;
          padding: 0 100px;
          font-size: 20px;
          font-weight: bold;
          box-sizing: border-box;
          text-align: start;
          line-height: 30px;

          .title1 {
            font-size: 40px;
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .szhjs_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
    }
  }

  .zyxt_box {
    width: 100%;
    height: auto;
    box-sizing: border-box;

    img {
      width: 100%;
    }
  }

  .news_box {
    width: 100%;
    margin-bottom: 50px;
    height: auto;
    box-sizing: border-box;

    .title {
      width: 100%;
      height: 180px;
      font-size: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .new_list {
      width: 65%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .news {
        width: 48%;
        height: 800px;
        position: relative;
        cursor: pointer;

        &:hover {
          .img {
            img {
              transform: scale(1.1);
            }
          }
        }

        .tag {
          width: 100px;
          height: 36px;
          line-height: 36px;
          background-color: rgba(0, 0, 0, 0.3);
          position: absolute;
          left: 20px;
          z-index: 2;
          color: rgba(255, 255, 255, 1);
        }

        .img {
          // width: 100%;
          max-width: 600px;
          height: 500px;
          overflow: hidden;

          img {
            transition: 0.3s all;
            width: 100%;
            height: 100%;
          }
        }

        .tips_box {
          width: 100%;
          background-color: #f8f8f8;
          text-align: start;
          padding: 20px;
          box-sizing: border-box;

          .title2 {
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
}
</style>